import React from 'react';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import './SportOneWellnessHubCard.scss';

const wellnessCards = [
  {
    title: "Wellness Hub 1",
    description: "One place for all your well-being needs",
    gear: [
      { img: "tshirt.jpeg", label: "Tshirts" },
      { img: "joggers.jpg", label: "Joggers" },
      { img: "sportsbra.jpeg", label: "Sports Bra" },
      { img: "yogapants.jpg", label: "Yoga Pants" },
    ],
  },
  {
    title: "Wellness Hub 2",
    description: "Elevate your game-day gear",
    gear: [
      { img: "w18-players.jpeg", label: "W18-Badminton court" },
      { img: "w18-badminton-court.jpeg", label: "W18-Badminton court" },
      { img: "w18-yoga.jpeg", label: "W18-Yoga" },
      { img: "w18-cafiteria.jpeg", label: "W18-Cafeteria" },
    ],
  },
  {
    title: "Wellness Hub 3",
    description: "Elevate your game-day gear",
    gear: [
      { img: "https://static.wixstatic.com/media/75dc1e_e1802cd0f11049c19a9c870d104b3d98~mv2.jpg/v1/fill/w_1889,h_1154,al_c,q_90,enc_avif,quality_auto/75dc1e_e1802cd0f11049c19a9c870d104b3d98~mv2.jpg", label: "Brighter Minds" },
      { img: "https://heartfulness.org/_next/image?url=https%3A%2F%2Fprimary-cms.s3.ap-south-1.amazonaws.com%2Fstrapi-assets%2FBanner06b_f5fd11efa8.jpg&w=1080&q=75", label: "Heartfulness Yoga" },
      { img: "https://sportfitinc.com/wp-content/uploads/2025/01/Merrithew-Banner_Revolving-Banner.jpg", label: "Sportfit" },
      { img: "https://tournamentplanner.in/Screens/images/1.png", label: "TPLive" },
      { img: "https://firebasestorage.googleapis.com/v0/b/w18sportsuniverse.appspot.com/o/product_img%2FI1fqT0XOTvI9hSEGkr9t%2FFITNESS.webp?alt=media&token=7ca3ad6e-b895-45bd-befa-61028585cbb1", label: "W18-Fitness" },
      { img: "https://firebasestorage.googleapis.com/v0/b/w18sportsuniverse.appspot.com/o/product_img%2FlNc1XutEbejNFmYvSUdh%2Fcafeteria.webp?alt=media&token=5ff36681-6f86-403d-be32-2f5ecac03ce4", label: "W18-Cafeteria" },
    ],
  },
];

const carouselOptions = {
  loop: true,
  margin: 20,
  center: true,
  autoplay: true,
  autoplayTimeout: 2000,
  autoplayHoverPause: true,
  dots: false,
  nav: false,
  responsive: {
    0: {
      items: 1
    },
    600: {
      items: 1
    },
    700: {
      items: 1
    }
  }
};

const SportOneWellnessHubCard = () => {
  return (
    <section className="wellness-carousel">
      <OwlCarousel className="owl-theme wellness-carousel-main" {...carouselOptions}>
        {wellnessCards.map((card, cardIdx) => (
          <div className="wellness-hub-card" key={cardIdx}>
            <div className="left-section">
              <h2>{card.title}</h2>
              <p>{card.description}</p>
              <button className="gear-btn">
                WORKOUT GEAR <span className="arrow">→</span>
              </button>
            </div>

            <div className="right-section">
              <div className="gear-images">
                {card.gear.map((item, index) => (
                  <div key={index} className="item">
                    <img
                      src={
                        item.img.startsWith("http")
                          ? item.img
                          : `/assets/img/sports/sport-one/images/${item.img}`
                      }
                      alt={item.label}
                    />
                    <span>{item.label}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        ))}
      </OwlCarousel>
    </section>
  );
};

export default SportOneWellnessHubCard;

